export default __webpack_public_path__ + "static/media/cryofhavoc.fcda53f6.png";